export default __webpack_public_path__ + "static/media/photo--sm--124.1446642e.jpg";